import { EnvironmentProviders, Provider } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './auth.routes';

export const authProviders: Array<Provider | EnvironmentProviders> = [
  provideRouter(routes),
];
